import { render, staticRenderFns } from "./CompetitionListEntryLayout.vue?vue&type=template&id=f89ed8e6&scoped=true&"
import script from "./CompetitionListEntryLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionListEntryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89ed8e6",
  null
  
)

export default component.exports